/**
 * How markdown reads in the app's panels: headings, paragraphs, lists, code and quotes styled on the NextAdmin palette.
 * Passed to `SafeMarkdown` as `overrides` by the chat's assistant text and the dashboard's report outputs.
 */
export const MARKDOWN_OVERRIDES = {
  h1: { props: { className: 'mt-3 mb-2 text-lg font-semibold text-text-primary' } },
  h2: { props: { className: 'mt-3 mb-2 text-base font-semibold text-text-primary' } },
  h3: { props: { className: 'mt-2 mb-1 text-sm font-semibold text-text-primary' } },
  p: { props: { className: 'my-1.5 leading-relaxed first:mt-0 last:mb-0' } },
  ul: { props: { className: 'my-1.5 list-disc space-y-1 pl-5' } },
  ol: { props: { className: 'my-1.5 list-decimal space-y-1 pl-5' } },
  code: { props: { className: 'rounded-sm bg-background-gray-secondary_alt px-1 py-0.5 font-mono text-xs' } },
  pre: {
    props: { className: 'my-2 overflow-x-auto rounded-lg bg-background-gray-secondary_alt p-3 font-mono text-xs' },
  },
  strong: { props: { className: 'font-semibold text-text-primary' } },
  blockquote: { props: { className: 'my-2 border-l-2 border-card-border pl-3 text-text-tertiary' } },
};
